import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wordmark } from "../components/site/Wordmark";
import { LanguageSwitcher } from "../components/site/LanguageSwitcher";
import { Footer } from "../components/site/Footer";
import { useLang } from "../i18n/LanguageContext";

export const LegalPage = ({ docKey }) => {
  const { t } = useLang();
  const doc = t.legal[docKey];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#F4F3EF] text-[#1A1C19] antialiased min-h-screen flex flex-col">
      <header className="border-b border-stone-300/50">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo" aria-label="M&K Properties home">
            <Wordmark />
          </Link>
          <div className="flex items-center gap-6">
            <LanguageSwitcher />
            <Link
              to="/"
              data-testid="legal-back"
              className="inline-flex items-center gap-2 text-sm font-medium text-[#1A1C19] hover:text-[#5C5C59] transition-colors"
            >
              <ArrowLeft size={16} /> {t.legal.back}
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1" data-testid="legal-page">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.legal.legalLabel}
          </p>
          <h1
            data-testid="legal-title"
            className="font-serif text-4xl md:text-5xl tracking-tight text-[#1A1C19]"
          >
            {doc.title}
          </h1>
          <p className="mt-4 text-sm text-[#5C5C59]">{doc.updated}</p>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#5C5C59]">
            {doc.intro}
          </p>

          <div className="mt-12 space-y-10">
            {doc.sections.map((s, i) => (
              <section key={i} data-testid={`legal-section-${i}`}>
                <h2 className="font-serif text-2xl text-[#1A1C19]">
                  {s.heading}
                </h2>
                <p className="mt-3 text-base leading-relaxed text-[#5C5C59]">
                  {s.body}
                </p>
              </section>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
